import { Button, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement, useState } from 'react';
import { ModalUnsavedChangesVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalUnsavedChangesVariantProps;

export const UnsavedChangesModal = ({
  handleClose,
  isShown,
  message = 'Du hast ungespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?',
  onConfirm,
  onCancel,
  onSaveAndLeave,
}: Props): ReactElement => {
  const [isSavingAndLeaving, setIsSavingAndLeaving] = useState(false);

  const handleSaveAndLeave = async (): Promise<void> => {
    if (!onSaveAndLeave) {
      handleClose();
      return;
    }

    setIsSavingAndLeaving(true);
    try {
      await onSaveAndLeave();
    } finally {
      setIsSavingAndLeaving(false);
    }
  };

  const handleConfirm = (): void => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  const handleCancel = (): void => {
    if (onCancel) {
      onCancel();
    }
    handleClose();
  };

  return (
    <CustomModal isOpen={isShown} onClose={handleCancel} placement="center" size="md" hideHeader>
      <CustomModalContent py="s" px="l">
        <VStack textAlign="center" gap="m">
          <Text textStyle="body.m.regular" my="5">
            {message}
          </Text>
          <Button
            onClick={handleSaveAndLeave}
            variant="primary"
            w={{ base: 'full', md: '250px' }}
            loading={isSavingAndLeaving}
            disabled={isSavingAndLeaving}
          >
            Speichern und verlassen
          </Button>
          <Button
            onClick={handleCancel}
            variant="secondaryOutline"
            w={{ base: 'full', md: '250px' }}
            disabled={isSavingAndLeaving}
          >
            Hier bleiben
          </Button>
          <Button
            onClick={handleConfirm}
            variant={{ base: 'destructiveOutline', md: 'destructive' }}
            disabled={isSavingAndLeaving}
          >
            Änderungen verwerfen
          </Button>
        </VStack>
      </CustomModalContent>
    </CustomModal>
  );
};
